/**
 * region for libraries*/
import React from 'react';

function TabPanel(props) {
    const { children } = props;
    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
}
export default TabPanel